import { takeLatest, put } from 'redux-saga/effects';

import {
  CANCEL_PRAGA_DOENCA_RAPIDO,
  CANCEL_PRAGA_DOENCA_RAPIDO_SUCCESS,
} from '../actionTypes';

function* sagaCancelPragaDoencaRapido() {
  yield put({ type: CANCEL_PRAGA_DOENCA_RAPIDO_SUCCESS })
}

export default function* watchCancelPragaDoencaRapido() {
  yield takeLatest(CANCEL_PRAGA_DOENCA_RAPIDO, sagaCancelPragaDoencaRapido)
}
